import React from "react";
import PropTypes from "prop-types";
import { Headline, Surface } from "@mm/ui";

import { OfferProvider } from "features/Offer";

import { PageHeader, PageFooter } from "components/organisms";
import { StandardPageTemplate } from "components/templates";
import { Breadcrumb } from "components/atoms";

import Filter from "features/Filter/index";
import FilterSection from "features/Filter/FilterSection";
import filterConfig from "features/Filter/config";

import {
  useHardwaresListing,
  useListingSections,
  useManufacturer,
} from "utils/fetchData";

import RenderListingSections from "sections/RenderListingSections";

import Sections from "../sections";

const { shownFacets } = filterConfig;

const HardwareListingHeader = ({ queryParams }) => {
  const breadcrumb = window.BREADCRUMB;
  const { data } = useManufacturer({ ...queryParams });

  // map all manufacturers and breadcrumb item texts into to arrays.
  const manufacturers = data?.map((item) => item.name);
  const breadcrumbManufacturer = breadcrumb?.map((item) => item.text);

  // find manufacturer by breadcrumb items and manufacturer call
  const findManufacturer = () => {
    if (manufacturers?.length >= 1) {
      return breadcrumbManufacturer.filter((item) =>
        manufacturers.includes(item)
      );
    }
    return "";
  };

  const activeManufacturer = findManufacturer().toString();

  return (
    <Surface
      variant="narrow"
      mt={[4, 4, 4, 6, 6]}
      display="flex"
      flexDirection={[
        "column-reverse",
        "column-reverse",
        "column-reverse",
        "column",
        "column",
      ]}
    >
      <Headline variant="h1">
        Unsere {activeManufacturer} Geräteauswahl
      </Headline>
      {breadcrumb && breadcrumb.length && (
        <Breadcrumb isListingPage items={breadcrumb} />
      )}
    </Surface>
  );
};

const HardwareListingPage = ({ queryParams }) => {
  const { data } = useHardwaresListing({ ...queryParams, sort: "listPage" });
  const { data: listingSection } = useListingSections(
    { ...queryParams },
    queryParams.type
  );

  if (!listingSection) {
    return null;
  }

  const { sections } = listingSection;

  return (
    <OfferProvider queryParams={queryParams} isTariff isListingPage>
      <Filter
        variant="smartphone"
        queryParams={queryParams}
        data={data}
        shownFacets={shownFacets.hardwareListingPage}
      >
        <StandardPageTemplate
          breadcrumb={<HardwareListingHeader queryParams={queryParams} />}
          header={<PageHeader itemCount={1} />}
          sections={[
            // eslint-disable-next-line react/jsx-key
            <RenderListingSections sections={sections} />,
            // eslint-disable-next-line react/jsx-key
            <FilterSection variant="smartphone" />,
            // eslint-disable-next-line react/jsx-key
            <Sections.RichSEOSection />,
          ]}
          footer={<PageFooter />}
        />
      </Filter>
    </OfferProvider>
  );
};

HardwareListingPage.propTypes = {
  queryParams: PropTypes.shape({}),
};

HardwareListingPage.defaultProps = {
  queryParams: null,
};

export default HardwareListingPage;
